import { TextKey } from '@mews-commander/enums';
import { createAddFormConnect } from '../../entityManagement';
import { addContractFileAction } from '../actions';
import ContractForm from './ContractForm';

export default createAddFormConnect({ titleKey: TextKey.Contract, addAction: addContractFileAction })(ContractForm);
